window.addEventListener('load', () => {
    const element = document.querySelector('.product-tabs');

    if (!element) {
        return;
    }

    const buttons = element.querySelectorAll<HTMLButtonElement>('.tabs-nav button.tabs-nav-item');
    const tabs = element.querySelectorAll<HTMLElement>('.tabs-items .tabs-item');

    buttons.forEach((button) => {
        const type = button.getAttribute('data-tab');

        if (!type) {
            return;
        }

        const buttonTab = element.querySelector<HTMLElement>('.tabs-items .tabs-item--' + type);

        button.addEventListener('click', () => {
            buttons.forEach(btn => {
                btn.classList.remove('active');
            });

            tabs.forEach(tab => {
                tab.classList.remove('active');
            });

            button.classList.add('active');
            buttonTab.classList.add('active');
        });
    });
});